import ApplyParagraphAnnotations from "@elements/ArticleParagraph/ApplyParagraphAnnotations";
import { List, ListItem } from "@sphtech/sph-web-ui/elements/List";
import { ProcessedTextElement } from "@typings/Opensearch";
import { twMerge } from "tailwind-merge";

type ParagraphListProps = {
  listType: "ul" | "ol";
  listItems: ProcessedTextElement[];
  listStyle?: string;
};

export default function ParagraphList({
  listStyle,
  listType,
  listItems,
}: ParagraphListProps) {
  return (
    <List
      className={twMerge(
        "font-primary font-medium text-text-body text-[16px] leading-[150%] list-inside ps-[10px] mb-6 lg:mb-8",
        listStyle,
      )}
      Element={listType}
    >
      {listItems.map((item, idx) => (
        <ListItem testId={`item-${idx}`} key={idx}>
          <>{ApplyParagraphAnnotations(item.value, item.annotations)}</>
        </ListItem>
      ))}
    </List>
  );
}

export function ParagraphListMobile({
  listType,
  listItems,
}: ParagraphListProps) {
  return (
    <List Element={listType}>
      {listItems.map((item, idx) => (
        <ListItem testId={`item-${idx}`} key={idx}>
          <>{ApplyParagraphAnnotations(item.value, item.annotations)}</>
        </ListItem>
      ))}
    </List>
  );
}
